const BASE_URL = 'https://rkbforu.com/api/baseV1';
//const BASE_URL = 'https://rkbforu-uat2.eleservsoft.com/api/baseV1';
//const BASE_URL = 'http://localhost:9097/api/baseV1';


const Python_BASE_URL = 'https://rkbforu.com/pyapi/api/baseV1'
//const Python_BASE_URL = 'https://rkbforu-uat2.eleservsoft.com/pyapi/api/baseV1'
//const Python_BASE_URL = 'http://localhost:9098/api/baseV1'


 const Renko_Data_API = 'https://rkbforu.com:9027/'
// const Renko_Data_API = 'http://localhost:8080/'


//  ******prod its for telegram *****
 const CHAT_IDS = {
    Future: '-1001631194193',
    Options: '-1001747080302',
    Delivery: '-1001674828252',
    HNI: '-1002063080484',
    Commodity: '-1002138033725',
    IntraDay: '-1002163231873',
    IndexIntraday: '-1002163231873',
    Free:'-1001278461377',
    NKB:'-1002998915882',
    "F&O":'-1003218765031',
   };



// const CHAT_IDS = {
//    Future: '-1002082769311',
//    Options: '-1002082769311',
//   Delivery: '-1002082769311',
//    HNI: '-1002082769311',
//    Commodity: '-1002082769311',
//    IntraDay: '-1002082769311',
//    IndexIntraday: '-1002082769311',
//   Free:'-1002082769311',
//     NKB:'-1002082769311',
//    "F&O":'-1002082769311',
//  };
  
  //  ***** prod chat ids ********
  

 
  const Rigi_CHAT_IDS = {
      Future:'6a1fd97f22ee02bb9df63539',
      Options:'6a1fd39922ee02bb9df62677',
      Delivery:'6a1fd72122ee02bb9df62ec1',
      HNI:'6a2139ce46fd201f8b06a1c8',
      Commodity:'6a1fdb9a22ee02bb9df63a48',
      IndexIntraday:'6a2139ce46fd201f8b06a1c8',
      Free:'6a210011980ac1dbe8e9ff57',
      NKB:'6a1fc91722ee02bb9df61600',
     "F&O":'6a2139ce46fd201f8b06a1c8',
     }
   
//  const Rigi_CHAT_IDS = {
//   Future:'6a2139ce46fd201f8b06a1c8',
//   Options:'6a2139ce46fd201f8b06a1c8',
//   Delivery:'6a2139ce46fd201f8b06a1c8',
//   HNI:'6a2139ce46fd201f8b06a1c8',
//   Commodity:'6a2139ce46fd201f8b06a1c8',
//   IndexIntraday:'6a2139ce46fd201f8b06a1c8',
//   Free:'6a2139ce46fd201f8b06a1c8',
//   NKB:'6a2139ce46fd201f8b06a1c8',
//  "F&O":'6a2139ce46fd201f8b06a1c8',
//  }

  const Rigi_CHAT_NAME = {
   Future:'Future ka Boss',
   Options:'OPTION KA USTAAD',
   Delivery:'Delivery Dhamaka',
   HNI:'RKB HNI Channel',
   Commodity:'Commodity ka sikandar',
   IndexIntraday:'Eleserv Test Channel',
   Free:'Rakesh Bansal Ventures-RKB',
   NKB:'Index Ka Boss',
   "F&O":'Eleserv Test Channel'
  }

  
 
   const TELEGRAM_API_TOKEN ='6848586856:AAE_JEYn2MH2j16n0fYD-1V9adL0QDknS7I';

   // app/utils/config.js

// fetches the current RKB app (Rigi) token from the backend so it can be
// refreshed daily without rebuilding/redeploying the frontend
const getRkbAppToken = async () => {
  const loginuser = JSON.parse(localStorage.getItem("loginData"));
  const response = await fetch(`${BASE_URL}/getRkbAppToken`, {
    headers: { 'Authorization': `Bearer ${loginuser.token}` },
  });
  const data = await response.json();
  return data.token;
};
// Export variables
module.exports = {
    BASE_URL,
    Python_BASE_URL,
    CHAT_IDS,
    Rigi_CHAT_IDS,
    Rigi_CHAT_NAME,
    TELEGRAM_API_TOKEN,
    Renko_Data_API,
    getRkbAppToken
};
